import { compareTwo, sortByPinList } from '../components/crew-kanban/utils';
import { isToday } from '../helpers/common';
import {
    MOVE_COLUMN, MOVE_CARD, APPLY_FILTERS, CREW_SELECTION,
    GET_CREW_EQUIPMENT_GROUP_LIST_REQUEST, GET_CREW_EQUIPMENT_GROUP_LIST,
    KANBAN_GET_CREW_LIST_REQUEST, KANBAN_GET_CREW_LIST, KANBAN_GET_CREW_INFO, KANBAN_GET_CREW_INFO_REQUEST,
    UPDATE_CREW_INFO, GET_WORK_PLAN_REQUEST, GET_WORK_PLAN, CLEAR_CREW_KANBAN, CREATE_CREW,
    CREW_SAVE_REQUEST, RESET_CREW, CREW_SAVE_SUCCESS, CREW_SAVE_FAILURE, CREW_GET_GEO_REGION_REQUEST,
    CREW_GET_GEO_REGION, ASSIGNED_EG, KANBAN_GET_CREW_INFO_ASSIGN, REMOVE_ASSIGN_CREW, CREW_ASSIGN_SAVE, SET_CREW_SEARCH_TEXT, SET_CREW_FILTERED_LIST
} from '../constants/action-types';
import { Unit } from '../helpers/unit';
import { getAreaOfPolygon } from 'geolib';

const getColumns = (count, selected) =>
    Array.from({ length: count }, (v, k) => k).map(k => ({
        columnId: `column${k + 1}`,
        crewId: (selected && k < selected.length) ? selected[k] : null
    }));

const initialState = {
    refresh: 0,
    isRequestingEg: false,
    isRequestingCrew: false,
    isRequestingSave: false,
    isRequestingGeoRegion: false,
    filters: {
        farmId: null,
        planTypeId: 4,
        isRecentlyUpdated: false,
        isSelectedPlanUpdated: false
    },
    columns: getColumns(5),
    crews: {
        unassigned: { egList: [] },
        assigned: { egList: [] }
    },
    egListById: {},
    allCrewList: [],
    crewList: [],
    newCrewList: [],
    fieldListById: {},
    isAssignCrewCall: false,
    crewSearchText: "",
    crewFilteredList: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case KANBAN_GET_CREW_LIST_REQUEST:
            return {
                ...state, isRequestingCrew: true,
                allCrewList: initialState.allCrewList, crewList: initialState.crewList
            };
        case KANBAN_GET_CREW_LIST: {
            const allCrewList = action.payload ? sortByPinList(action.payload).filter(e => (isToday(action.range) ? e.alive : true)) : initialState.crewList;
            const crewList = allCrewList.filter(e => e.plan_type_id === state.filters.planTypeId);
            return { ...state, isRequestingCrew: false, allCrewList, crewList };
        }
        case APPLY_FILTERS: {
            const filters = action.payload;
            if (filters.hasOwnProperty("planTypeId") && filters.planTypeId !== state.filters.planTypeId) {
                const filterCrewList = state.allCrewList.filter(e => e.plan_type_id === filters.planTypeId);
                return { ...state, filters: { ...state.filters, ...filters }, crewList: filterCrewList, newCrewList: [] };
            }
            return { ...state, filters: { ...state.filters, ...filters } };
        }
        case CREW_SELECTION: {
            const columns = [...state.columns];
            const crews = { ...state.crews };
            const oldSelected = columns.filter(e => e.crewId !== null).map(e => e.crewId);
            const newSelected = action.payload;
            const { added, removed } = compareTwo(oldSelected, newSelected);

            for (const crewId of removed) {
                const findIndex = columns.findIndex(e => e.crewId === crewId);
                if (findIndex < 0) continue;
                columns[findIndex].crewId = null;
                if (crews.hasOwnProperty(crewId)) delete crews[crewId];
            }

            for (const crewId of added) {
                const findIndex = columns.findIndex(e => e.crewId === null);
                if (findIndex < 0) continue;
                columns[findIndex].crewId = crewId;
            }

            return { ...state, columns, crews };
        }
        case MOVE_COLUMN:
            const { oldColumnIndex, newColumnIndex } = action.payload;
            const newColumns = Array.from(state.columns);
            const [removedList] = newColumns.splice(oldColumnIndex, 1);
            newColumns.splice(newColumnIndex, 0, removedList);
            return { ...state, columns: newColumns };
        case MOVE_CARD: {
            const { oldCardIndex, newCardIndex, sourceCrewId, destCrewId } = action.payload;
            // Move within the same list
            if (sourceCrewId === destCrewId) {
                const newCards = Array.from(state.crews[sourceCrewId].egList);
                const [removedCard] = newCards.splice(oldCardIndex, 1);
                newCards.splice(newCardIndex, 0, removedCard);
                return {
                    ...state,
                    crews: { ...state.crews, [sourceCrewId]: { ...state.crews[sourceCrewId], egList: newCards } }
                };
            }

            // Move card from one list to another

            const sourceCards = state.crews[sourceCrewId] ? Array.from(state.crews[sourceCrewId].egList) : [];
            const [removedCard] = sourceCards.splice(oldCardIndex, 1);
            const destinationCards = state.crews[destCrewId] ? Array.from(state.crews[destCrewId].egList) : [];
            destinationCards.splice(newCardIndex, 0, removedCard);
            return {
                ...state, crews: {
                    ...state.crews,
                    [sourceCrewId]: { ...state.crews[sourceCrewId], egList: sourceCards, isChanged: true },
                    [destCrewId]: { ...state.crews[destCrewId], egList: destinationCards, isChanged: true }
                }
            };
        }
        case GET_CREW_EQUIPMENT_GROUP_LIST_REQUEST:
            return { ...state, isRequestingEg: true, egListById: {} };
        case GET_CREW_EQUIPMENT_GROUP_LIST: {
            const egList = action.payload ? action.payload : [];

            // Id wise EG list
            const egListById = {};
            for (const item of egList)
                egListById[item.equipment_group_uuid] = {
                    ...item,
                    ...!item.vehicle.is_truck ? { acres_per_day: 0 } : {},
                    crewId: (item.crew && item.crew.crew_uuid && item.crew.crew_uuid.length > 0) ?
                        item.crew.crew_uuid : "unassigned"
                };

            // Unassigned crew
            const unassigned = {
                egList: egList
                    .filter(e => !(e.crew && e.crew.crew_uuid && e.crew.crew_uuid.length > 0))
                    .map(e => ({ id: e.equipment_group_uuid, name: e.equipment_group_name }))
            };

            return { ...state, isRequestingEg: false, egListById, crews: { ...state.crews, unassigned } };
        }
        case KANBAN_GET_CREW_INFO_REQUEST: {
            const crewId = action.crewId;
            return {
                ...state, crews: {
                    ...state.crews,
                    [crewId]: {
                        info: action.payload, egPlanById: {}, egList: [],
                        isRequesting: true, isRequestingPlan: false, isEditMode: true
                    }
                }
            };
        }
        case KANBAN_GET_CREW_INFO: {
            const crewId = action.crewId;
            if (!action.crewId) return state;
            if (!action.payload) return { ...state, crews: { ...state.crews, [crewId]: { ...state.crews[crewId], isRequesting: false, egList: [] } } };

            const crewInfo = action.payload;
            const crewEgList = crewInfo.equipment_group_list;
            const isHaveWorkPlan = crewInfo.is_end_crew ? false : crewInfo.is_work_plan;

            // EG wise plan detail
            const egPlanById = {}, egListByEGId = state.egListById;
            for (const item of crewEgList) {
                const egId = item.equipment_group_uuid;
                if (!egListByEGId[egId]) continue;
                if (egListByEGId[egId] && egListByEGId[egId].vehicle.is_truck) continue;
                egPlanById[egId] = { acres_per_day: item.acres_per_day };
            }

            delete crewInfo.equipment_group_list;
            return {
                ...state, egListById: egListByEGId,
                crews: {
                    ...state.crews, [crewId]: {
                        ...state.crews[crewId], egPlanById,
                        info: { ...crewInfo, isHaveWorkPlan },
                        egList: crewEgList.map(e => ({ id: e.equipment_group_uuid, name: e.equipment_group_name })),
                        isRequesting: false,
                    }
                }
            };
        }
        case KANBAN_GET_CREW_INFO_ASSIGN: {
            const crewId = action.crewId;
            if (!action.crewId) return state;
            if (!action.payload) return { ...state, crews: { ...state.crews, [crewId]: { ...state.crews[crewId], isRequesting: false, egList: [] } } };
            const { isAssign, egId } = action.assignedObj;
            const crewInfo = action.payload;
            let crewEgList = [];
            if (isAssign) {
                crewEgList = crewInfo.equipment_group_list.filter((e) => e.equipment_group_uuid !== egId);
            } else {
                crewEgList = crewInfo.equipment_group_list;
            }
            const isHaveWorkPlan = crewInfo.is_end_crew ? false : crewInfo.is_work_plan;

            // EG wise plan detail
            const egPlanById = {}, egListByEGId = state.egListById;
            for (const item of crewEgList) {
                const egId = item.equipment_group_uuid;
                if (!egListByEGId[egId]) continue;
                if (egListByEGId[egId] && egListByEGId[egId].vehicle.is_truck) continue;
                egPlanById[egId] = { acres_per_day: item.acres_per_day };
            }

            delete crewInfo.equipment_group_list;
            return {
                ...state, egListById: egListByEGId,
                crews: {
                    ...state.crews, [crewId]: {
                        ...state.crews[crewId], egPlanById,
                        info: { ...crewInfo, isHaveWorkPlan },
                        egList: crewEgList.map(e => ({ id: e.equipment_group_uuid, name: e.equipment_group_name })),
                        isRequesting: false,
                        ...isAssign && { isChanged: true }
                    }
                }
            };
        }
        case GET_WORK_PLAN_REQUEST: {
            const crewId = action.crewId;
            return { ...state, crews: { ...state.crews, [crewId]: { ...state.crews[crewId], isRequestingPlan: true } } };
        }
        case GET_WORK_PLAN: {
            const crewId = action.crewId;
            if (!state.crews.hasOwnProperty(crewId) || !state.crews[crewId].info.isHaveWorkPlan) return state;
            if (!action.payload) return { ...state, crews: { ...state.crews, [crewId]: { ...state.crews[crewId], isRequestingPlan: false } } };

            const workPlan = action.payload;
            const planEgList = workPlan.equipment_group_list;
            const crew = state.crews[crewId];

            // EG wise plan detail
            const egPlanById = {};
            for (const item of planEgList) {
                const egId = item.equipment_group_uuid;
                if (crew.egList.indexOf(egId) < 0) continue;
                egPlanById[egId] = { acres_per_day: item.acres_per_day };
            };

            return {
                ...state, crews: {
                    ...state.crews, [crewId]: {
                        ...crew,
                        info: {
                            ...crew.info,
                            total_working_days: workPlan.total_working_days,
                            acres_per_day: workPlan.acres_per_day,
                            acres_per_hour: workPlan.acres_per_hour
                        },
                        egPlanById,
                        isRequestingPlan: false
                    }
                }
            };
        }
        case UPDATE_CREW_INFO: {
            const crewId = action.crewId;
            const isEditMode = state.crewList.map(e => e.crew_uuid).indexOf(crewId) >= 0;

            let newCrewList = state.newCrewList;

            if (!isEditMode) {
                newCrewList = newCrewList.map(item => {
                    if (item.crew_uuid === crewId)
                        return ({
                            crew_uuid: crewId,
                            crew_name: action.payload.crew_name,
                            plan_type_id: state.filters.planTypeId
                        })
                    else return item;
                })
            }
            return {
                ...state, crews: {
                    ...state.crews, [crewId]: {
                        ...state.crews[crewId], isChanged: true, isEditMode,
                        info: { ...state.crews[crewId].info, ...action.payload }
                    }
                }, newCrewList
            };
        }
        case CREATE_CREW: {
            const newCrewId = action.crewId;
            const crewColumns = [...state.columns];

            const findIndex = crewColumns.findIndex(e => e.crewId === null);
            if (findIndex >= 0) crewColumns[findIndex].crewId = newCrewId;

            return {
                ...state, columns: crewColumns,
                crews: {
                    ...state.crews, [newCrewId]: {
                        isRequesting: false, isRequestingPlan: false, isEditMode: false, isChanged: true,
                        egPlanById: {}, egList: [],
                        info: {
                            total_working_days: 1, acres_per_day: 0, acres_per_hour: 0,
                            ...action.payload, crew_uuid: newCrewId,
                            isHaveWorkPlan: action.payload.is_work_plan
                        },
                    }
                },
                newCrewList: [...state.newCrewList, {
                    crew_uuid: newCrewId,
                    crew_name: action.payload.crew_name,
                    plan_type_id: state.filters.planTypeId
                }]
            };
        }
        case ASSIGNED_EG: {
            let crewIds = [];
            state.crewList.forEach((each) => {
                crewIds.push(each.crew_uuid)
            });
            const egList = [];
            for (let egListById in state.egListById) {
                if (state.egListById[egListById] && crewIds.includes(state.egListById[egListById].crewId)) {
                    egList.push(state.egListById[egListById])
                }
            }
            const assigned = [];
            egList.filter((e) => e.crew && e.crew.crew_uuid && e.crew.crew_uuid.length > 0).forEach((each) => {
                if (!state.columns.map((e) => e.crewId).filter((e) => e).includes(each.crewId)) assigned.push({ id: each.equipment_group_uuid, name: each.equipment_group_name })
            })
            return { ...state, crews: { ...state.crews, assigned: { egList: assigned } } };

        }
        case RESET_CREW: {
            const egList = Object.keys(state.egListById).map(e => state.egListById[e]);
            // Unassigned crew
            const unassigned = {
                egList: egList
                    .filter(e => !(e.crew && e.crew.crew_uuid && e.crew.crew_uuid.length > 0))
                    .map(e => ({ id: e.equipment_group_uuid, name: e.equipment_group_name }))
            };

            //Assigned Crew
            const assigned = {
                egList: egList
                    .filter(e => (e.crew && e.crew.crew_uuid && e.crew.crew_uuid.length > 0))
                    .map(e => ({ id: e.equipment_group_uuid, name: e.equipment_group_name }))
            };

            const crews = { ...state.crews, unassigned, assigned };
            const columns = [...state.columns];

            state.newCrewList.forEach(item => {
                const findIndex = columns.findIndex(e => (e.crewId === item.crew_uuid));
                if (findIndex >= 0) columns[findIndex].crewId = null;
                if (crews.hasOwnProperty(item.crew_uuid)) delete crews[item.crew_uuid];
            });

            return {
                ...state, refresh: state.refresh + 1, columns, crews, newCrewList: [],
                filters: { ...state.filters, isRecentlyUpdated: false }
            };
        }
        case CREW_GET_GEO_REGION_REQUEST:
            return {
                ...state,
                // geoRegionList: initialState.geoRegionList,
                isRequestingGeoRegion: true
            }
        case CREW_GET_GEO_REGION: {
            const payload = action.payload ? action.payload : [];
            const fieldListById = {};
            const unit = Unit.getInstance();

            if (payload) payload.forEach(item => {
                item.shapes && item.shapes.forEach(e => {
                    const setOfLocation = (e.geo_shape_type === "polygon" && e.location) ? e.location.map(points => [points.lng, points.lat]) : [];
                    const totalAcres = unit.toArea(getAreaOfPolygon(setOfLocation) * 0.000247105, 2);
                    const regionDetails = { ...item, totalAcres };
                    delete regionDetails.shapes;
                    fieldListById[e.geo_shape_uuid] = { ...e, regionDetails }
                });
            });

            return { ...state, fieldListById: fieldListById, isRequestingGeoRegion: false }
        }
        case CREW_SAVE_REQUEST:
            return { ...state, isRequestingSave: true };
        case CREW_SAVE_SUCCESS:
            return { ...state, isRequestingSave: false, refresh: state.refresh + 1, newCrewList: [] };
        case CREW_SAVE_FAILURE:
            return { ...state, isRequestingSave: false };
        case CLEAR_CREW_KANBAN:
            return { ...initialState, filters: { ...initialState.filters, planTypeId: state.filters.planTypeId, isSelectedPlanUpdated: state.filters.isSelectedPlanUpdated } };
        case REMOVE_ASSIGN_CREW:
            const payload = action.payload;
            let crews = state.crews;
            payload.forEach((each) => {
                let getCrew = state.crews[each.crew_uuid];
                if (getCrew) {
                    delete crews[each.crew_uuid];
                }
            })
            return { ...state, crews };
        case CREW_ASSIGN_SAVE:
            const { isAssign } = action;
            return { ...state, isAssignCrewCall: isAssign };
        case SET_CREW_SEARCH_TEXT:
            const { searchText } = action;
            return { ...state, crewSearchText: searchText }
        case SET_CREW_FILTERED_LIST:
            const { crewFilteredList } = action;
            return { ...state, crewFilteredList }
        default:
            break;
    }
    return state;
}
